import { useState } from 'react';

import { Spinner } from '../../../shared/ui/spinner';
import AddRecordModal from '../../../components/AddRecordModal/AddRecordModal';
import AddGoalModal from '../../../components/goalModal/AddGoalModal';
import { useOverviewCurrency } from '../../../context/OverviewCurrencyContext';
import { useDashboardData } from '../model/use-dashboard-data';
import { ExpensesChart, OverviewChart } from './charts';
import { Stats } from './stats';
import { RecentTransactions } from './recent-transactions';

import styles from './dashbord.module.css';

export function Dashboard() {
	const { currency: overviewCurrency } = useOverviewCurrency();

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const [modalTab] = useState('expense');

	const {
		isLoading,
		hasCurrencyData,
		statValues,
		overviewGoal,
		goalsCount,
		chartData,
		transactions,
		expenses,
		expenseCategories,
		refresh,
	} = useDashboardData(overviewCurrency);

	if (isLoading) {
		return <Spinner />;
	}

	return (
		<div className={styles.container}>
			<div className={styles.main}>
				<div className={styles.content}>
					<Stats
						values={hasCurrencyData ? statValues : undefined}
						currency={overviewCurrency}
						overviewGoal={hasCurrencyData ? overviewGoal : null}
						goalsCount={goalsCount}
					/>

					<div className={styles.chartsGrid}>
						<RecentTransactions transactions={transactions} />
						<div className={styles.chartsColumn}>
							<OverviewChart data={chartData} currency={overviewCurrency} />
							<ExpensesChart
								expenses={expenses}
								categories={expenseCategories}
								currency={overviewCurrency}
							/>
						</div>
					</div>
				</div>
			</div>

			<AddGoalModal
				open={isAddModalOpen}
				onClose={() => setIsAddModalOpen(false)}
			/>
			<AddRecordModal
				open={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				onSuccess={refresh}
				defaultTab={modalTab}
			/>
		</div>
	);
}
